module.exports = __webpack_public_path__ + "static/img/huodong_bg.b404882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huodong_bg.png
// module id = 34m0
// module chunks = 128